import { NumberCircled } from '@pages/CreateNewProductPage/styles';
import { PropsWithChildren } from 'react';
import styles from './Step.module.scss';

interface StepProps extends PropsWithChildren {
  title: string;
  required?: boolean;
  position?: string | number;
}

export function Step({ title, required, position, children }: Readonly<StepProps>) {
  return (
    <div className={styles.root}>
      {position && <NumberCircled>{position}</NumberCircled>}
      <div className={styles.inner}>
        <div className={styles.title}>
          <h3>{title}</h3>
          {required && <sub>(required)</sub>}
        </div>
        {children}
      </div>
    </div>
  );
}
